import { keepPreviousData } from '@tanstack/react-query';
import { EnterpriseRelationshipOverviewEntry, useRepositoryQuery } from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';

export const useGetEnterpriseRelationshipsOverviewEntries = (
    tableState: TableState<EnterpriseRelationshipOverviewEntry>,
    enterpriseId: string
) =>
    useRepositoryQuery(
        'enterpriseRelationships',
        'getOverviewEntries',
        { ...tableState, enterpriseId },
        {
            placeholderData: keepPreviousData,
        }
    );
